var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3.5,
    width: 4,
    height: 18,
    rx: 1,
    fill: "#F3BB56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 3.5,
    width: 4,
    height: 18,
    rx: 1,
    fill: "#F3BB56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4004 0H4.59963C4.03379 0 3.56907 0.421923 3.50703 0.966559C3.50238 1.00736 3.5 1.04885 3.5 1.09092V22.9091C3.5 22.9468 3.50192 22.984 3.50568 23.0208C3.56189 23.5715 4.02941 24 4.59963 24H20.0194H32.4286C33.0212 24 33.5 23.5125 33.5 22.9091V13.6575V1.09092C33.5 1.08208 33.4999 1.07327 33.4997 1.06448C33.4995 1.05678 33.4992 1.04909 33.4989 1.04142C33.498 1.02053 33.4964 0.999809 33.4943 0.97923C33.4381 0.428473 32.9706 0 32.4004 0ZM29.7065 19.875H19.3454H7.38994H7.29019C7.14285 19.875 7.02232 19.7523 7.02232 19.6023C7.02232 19.5712 7.02773 19.5408 7.03779 19.5121C7.04868 19.4809 7.06505 19.4516 7.08593 19.425L12.7879 12.5386C12.8688 12.4387 13.0009 12.383 13.1165 12.3871C13.2321 12.3912 13.3328 12.4328 13.4207 12.5045C13.424 12.5078 13.4277 12.5111 13.4315 12.5145C13.4356 12.5182 13.4399 12.5221 13.4441 12.5262C13.4479 12.5301 13.4516 12.5342 13.455 12.5386L16.689 16.3473L23.0885 7.83896C23.1741 7.73318 23.3238 7.71253 23.4358 7.78235C23.4397 7.78473 23.4434 7.78718 23.4471 7.78978L23.4504 7.79209C23.456 7.79611 23.4615 7.80038 23.4669 7.80488C23.4701 7.80816 23.4737 7.81145 23.4774 7.81486C23.4852 7.82203 23.4936 7.82972 23.5004 7.83896L29.9208 19.4284C30.0078 19.5409 29.9944 19.7148 29.8806 19.8102C29.8318 19.8519 29.7702 19.8749 29.7065 19.875ZM12.9155 4.90908C14.1286 4.90908 15.1148 5.8875 15.1148 7.09092C15.1148 8.29433 14.1286 9.27272 12.9155 9.27272C12.8896 9.27272 12.8638 9.27227 12.8381 9.27139C12.8231 9.27087 12.8082 9.2702 12.7932 9.26939C12.7538 9.2716 12.7141 9.27272 12.6741 9.27272C11.4922 9.27272 10.5312 8.29433 10.5312 7.09092C10.5312 5.8875 11.4922 4.90908 12.6741 4.90908C12.7141 4.90908 12.7538 4.9102 12.7932 4.91242C12.8337 4.9102 12.8745 4.90908 12.9155 4.90908Z",
    fill: "#EEA111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.dab8605886927576b7c68f7dccee74e8.svg";
export { ForwardRef as ReactComponent };